<template>
	<v-row class="ma-0">
		<v-col class="pa-0 px-2">
			<v-tabs 
				app
				show-arrows
				:height="32"
				class="tabs-route"
				:background-color="color"
				slider-color="primary">
				<template v-for="(tab, i) in tabs">
					<v-tab
						v-if="showTab(tab)"
						exact-path
						:to="{ path: tab.to, query: tab.query ? $route.query : '' }"
						:key="i">
						{{ $trans(tab.text) }}
					</v-tab>        
				</template>
			</v-tabs>
			<div id="mainTabs" ref="main">
				<v-slide-y-reverse-transition>
					<router-view v-show="!$store.getters.progress" :key="$route.fullPath"></router-view>
				</v-slide-y-reverse-transition>
			</div>
		</v-col>
	</v-row>
</template>

<script>
import { isTabAllowed } from '@/components/utilities/tabGates.js'

export default {
	name:'app-tabs',
	props: {
		tabs: Array,
		color: {
			default: 'transparent',
			type: String
		}
	},

	data() {
		return {
		}
	},

	computed: {
		showTab() {
			return tab => isTabAllowed(tab, this.$store.getters)
		}
	},
}
</script>
<style>
</style>